import {
	CartesianGrid,
	Legend,
	Line,
	LineChart,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from "recharts";
import { ClientOnly } from "~/components/ui/client-only";
import type { YearSummary } from "~/types/financials";

interface RatioTrendChartProps {
	years: YearSummary[];
}

const RATIO_LINES = [
	{ key: "roe", label: "ROE", color: "#0072FF" },
	{ key: "roa", label: "ROA", color: "#7517F8" },
	{ key: "profitMargin", label: "Zisková marže", color: "#0E9F6E" },
	{ key: "currentRatio", label: "Běžná likvidita", color: "#FF9F45" },
];

export function RatioTrendChart({ years }: RatioTrendChartProps) {
	const data = years.map((y) => ({
		year: y.year.toString(),
		roe: y.ratios.returnOnEquity != null ? +(y.ratios.returnOnEquity * 100).toFixed(1) : null,
		roa: y.ratios.returnOnAssets != null ? +(y.ratios.returnOnAssets * 100).toFixed(1) : null,
		profitMargin: y.ratios.profitMargin != null ? +(y.ratios.profitMargin * 100).toFixed(1) : null,
		currentRatio: y.ratios.currentRatio,
	}));

	return (
		<div className="card-surface rounded-xl p-6">
			<h3 className="text-lg font-semibold mb-4">Vývoj ukazatelů</h3>
			<ClientOnly fallback={<div className="h-[300px] animate-pulse bg-muted rounded" />}>
				<ResponsiveContainer width="100%" height={300}>
					<LineChart data={data} margin={{ top: 5, right: 20, bottom: 5, left: 20 }}>
						<CartesianGrid strokeDasharray="3 3" stroke="#E4E5F2" />
						<XAxis dataKey="year" fontSize={12} />
						<YAxis fontSize={12} />
						<Tooltip
							formatter={(value, name) => {
								const line = RATIO_LINES.find((l) => l.key === String(name));
								const suffix = name === "currentRatio" ? "×" : " %";
								return [`${value ?? "–"}${suffix}`, line?.label ?? String(name)];
							}}
							labelFormatter={(label) => `Rok ${String(label)}`}
						/>
						<Legend
							formatter={(value) => {
								const line = RATIO_LINES.find((l) => l.key === value);
								return line?.label ?? String(value);
							}}
						/>
						{RATIO_LINES.map((line) => (
							<Line
								key={line.key}
								type="monotone"
								dataKey={line.key}
								stroke={line.color}
								strokeWidth={2}
								dot={{ fill: line.color, r: 3 }}
								connectNulls
							/>
						))}
					</LineChart>
				</ResponsiveContainer>
			</ClientOnly>
		</div>
	);
}
